import { render, staticRenderFns } from "./ClipboardInput.vue?vue&type=template&id=261bb886&scoped=true&"
import script from "./ClipboardInput.vue?vue&type=script&lang=js&"
export * from "./ClipboardInput.vue?vue&type=script&lang=js&"
import style0 from "./ClipboardInput.vue?vue&type=style&index=0&id=261bb886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261bb886",
  null
  
)

export default component.exports